<template>
  <div class="trainer-apply-qrcode">
    <avatar-header :avatar="coach.avatar" :title="`绑定您的私人教练：${coach.name}`" />
    <qr-code :step-count="3" :current-step="2" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AvatarHeader from '@/components/AvatarHeader';
import QRCode from '@/components/share/QRCode';

import { FETCH_COACH } from '@/store/trainer_apply/types';

const { mapState, mapActions } = createNamespacedHelpers('trainer_apply');

export default {
    computed: {
        ...mapState({
            coach: state => state.coach || {},
        }),
    },
    created() {
        const { id } = this.$route.params;
        this.fetchCoach({ id });
    },
    methods: {
        ...mapActions({
            fetchCoach: FETCH_COACH,
        }),
    },
    components: {
        AvatarHeader,
        QrCode: QRCode,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer_apply/QRCode.vue